module.exports = __webpack_public_path__ + "static/media/38-10.982f0101.mp3";